module.exports = __webpack_public_path__ + "static/media/1.b6ab5d57.svg";